import { Location } from '../../../shared/models';

export class InventoryLocation extends Location {
    current: number;
    color: string;
    size: number;
    isAtLocation: boolean;
    minimum: number;
    maximum: number;
    editMode: boolean;
    missQuantity: number;
    transferNotAllowed: boolean;

    constructor(data: InventoryLocation) {
        super();
        Object.assign(this, data);
    }

    updateMissQty(qty?: number) {
        this.missQuantity = qty || 0 - this.maximum || 0;
    }
}



// WEBPACK FOOTER //
// ./~/angular2-template-loader!./~/@angularclass/hmr-loader!./~/tslint-loader!./src/app/inventory/shared/models/inventory-location.ts